import axios from "axios"
import { Apis } from "constants/apis"
import { VerifyService } from "types/services"

const verify: VerifyService = async(payload) => {
    const { data } = await axios.post(`${Apis.VERIFY}`, payload)
    return data
}

export default verify